import * as React from "react";
const IconCheveronUp = ({ fill = "#212A3D", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "1em"}
    height="1em"
    fill={fill}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M11.293 7.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L12 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconCheveronUp;
